export enum AdobeGranteeFlowType {
    EXISTING_LIMITED = 'existing',
    NEW_INFO_ONLY = 'newInfoOnly',
    NEW_LIMITED = 'newLimited',
    NON_VG_CLIENT_LIMITED = 'nonVgClientLimited',
    NON_VG_CLIENT_INFO_ONLY = 'nonVgClientInfoOnly',
}

export type AdobeGranteeLimitedFlow =
    | AdobeGranteeFlowType.EXISTING_LIMITED
    | AdobeGranteeFlowType.NEW_LIMITED
    | AdobeGranteeFlowType.NON_VG_CLIENT_LIMITED;
